import { toast } from '@systemeio/ui'
import { UnprocessableContentError, ViolationInterface } from '@systemeio/util'
import React from 'react'
import { Dispatch, SetStateAction } from 'react'

type Parse422ErrorsType = Record<string, string>
type Options = {
  setCommonError?: (commonError: string) => void
}

const parse422Errors = (violations: ViolationInterface[]): Parse422ErrorsType => {
  const parsedViolations: Record<string, string> = {}

  violations.forEach(violation => {
    const { propertyPath, message } = violation

    parsedViolations[propertyPath] = parsedViolations[propertyPath]
      ? parsedViolations[propertyPath] + '\n' + message
      : message
  })

  return parsedViolations
}

const renderCommonErrorToast = (error: string) =>
  toast.error(
    React.createElement('p', {
      className: 'primary-link-container',
      dangerouslySetInnerHTML: { __html: error },
    }),
  )

export const handle422Error = <T>(
  e: unknown,
  setErrors: Dispatch<SetStateAction<T>>,
  options?: Options,
) => {
  if (e instanceof UnprocessableContentError) {
    const violations = e.errors.violations as ViolationInterface[]
    const parsedErrors = parse422Errors(violations)
    const { '': commonErrors, ...fieldErrors } = parsedErrors
    if (commonErrors) {
      if (options?.setCommonError) {
        options.setCommonError(commonErrors)
      } else {
        commonErrors.split('\n').forEach(renderCommonErrorToast)
      }
    }
    setErrors(prev => ({ ...prev, ...fieldErrors }))

    return fieldErrors
  }
}
